import { gql } from "@apollo/client";

const updateQuery = gql`
mutation UpdateLPGCards($qr_code: String = "", $extraa_user_id: bigint = null, $gogas_user_id: bigint = "", $phone_number: String = "") {
  update_gogas_lpg_cards(where: {qr_code: {_eq: $qr_code}}, _set: {extraa_user_id: $extraa_user_id, gogas_user_id: $gogas_user_id, phone_number: $phone_number}) {
    affected_rows
  }
}
`

export const UpdateLPGCards = async (
    data,
    client,
) => {
    try {
        // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
        // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id

        const resp = await client.mutate({
            mutation: updateQuery,
            // refetchQueries: [getQuery],
            variables: {
                "qr_code": data.qr_code.replace('#',''),
                "extraa_user_id": data?.user_id,
                "gogas_user_id": data?.gogas_user_id,
                "phone_number": data?.mobile
            },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    //   "x-hasura-admin-secret": "aseraadmin@1234",
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
                },
            },
        });
        if (resp.errors) {
            return { success: false }
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
        // showFailureAlert('Something went wrong while updating your cart');
    }
    return { success: true }
};